import { render, staticRenderFns } from "./certificateReasons.vue?vue&type=template&id=bc03fe6c&scoped=true"
import script from "./certificateReasons.vue?vue&type=script&lang=js"
export * from "./certificateReasons.vue?vue&type=script&lang=js"
import style0 from "./certificateReasons.vue?vue&type=style&index=0&id=bc03fe6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc03fe6c",
  null
  
)

export default component.exports